import { liningConstants } from "../../constants";
import { liningService } from "../../services";
import { alertActions } from "../alert.actions";

export const liningActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    liningService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: liningConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: liningConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: liningConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, status) {
  return (dispatch) => {
    dispatch(request(name, status));

    liningService.addParameter(name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: liningConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: liningConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: liningConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, status) {
  return (dispatch) => {
    dispatch(request(id, name, status));

    liningService.updateParameter(id, name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: liningConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: liningConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: liningConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    liningService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: liningConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: liningConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: liningConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: liningConstants.CLEAR };
}
